export const MAX_MB_FILE_SIZE = 25;

export const ACCEPTED_FILE_FORMATS = {
  "application/customTypes": [
    ".pdf",
    ".xls",
    ".xlsx",
    ".xlsb",
    ".xlsm",
    ".csv",
    ".doc",
    ".docx",
  ],
};

export const ACCEPTED_FILE_FORMATS_LABEL = "PDF, XLS, CSV, or DOC";

// Formats the AI extraction pipeline can read: PDF, plus the Office formats
// Microsoft Graph renders to PDF while downloading them from SharePoint.
// Shared by every upload surface that feeds AI Docs so they cannot drift apart.
export const AI_DOCS_ACCEPTED_FILE_FORMATS = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};

export const AI_DOCS_ACCEPTED_FILE_FORMATS_LABEL = "PDF, DOCX, or XLSX";

export const OFFLINE_REASON_OPTIONS: { label: string; value: string }[] = [
  { label: "Prospect Broker case", value: "prospectBrokerCase" },
  {
    label: "Current policy information not available",
    value: "currentPolicyInformationNotAvailable",
  },
  { label: "Tri-Network Dental", value: "triNetworkDental" },
  {
    label: "Plan Design cannot be accurately illustrated",
    value: "planDesignCannotBeAccuratelyIllustrated",
  },
  { label: "Other", value: "other" },
];

// Keep legacy values here so existing stored submissions and tests still validate.
export const OFFLINE_REASON_VALUES = [
  "prospectBrokerCase",
  "currentPolicyInformationNotAvailable",
  "triNetworkDental",
  "planDesignCannotBeAccuratelyIllustrated",
  "other",
  "variedClassStructure",
  "variedRates",
  "triOptionDental",
  "dualASOPlanOffering",
] as const;
